module.exports = __webpack_public_path__ + "static/media/RGB.3ce8a4b7.PNG";